import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Typography } from '@mui/material';
import { CallEndIcon, PhoneIcon } from '@sharedCR/coreDesignSystem/icons';

import { answerCallAction, hangupCallAction } from 'store/system/actions';

import { PRIMARY_ACTION_ICON_SIZE } from '../../MobileCallSurface.constants';
import {
  answerButtonStyles,
  controlLabelStyles,
  hangupButtonStyles,
  primaryActionCellStyles,
  primaryActionsRowStyles,
} from '../../MobileCallSurface.styles';

import { IncomingCallActionsTestIds } from './IncomingCallActions.testIds';

const IncomingCallActions = () => {
  const dispatch = useDispatch();

  const onAnswer = useCallback(() => {
    dispatch(answerCallAction());
  }, [dispatch]);

  const onDecline = useCallback(() => {
    dispatch(hangupCallAction());
  }, [dispatch]);

  return (
    <Box sx={primaryActionsRowStyles}>
      <Box sx={primaryActionCellStyles}>
        <Box
          aria-label="Decline"
          component="button"
          data-testid={IncomingCallActionsTestIds.DECLINE}
          sx={hangupButtonStyles}
          onClick={onDecline}
        >
          <CallEndIcon size={PRIMARY_ACTION_ICON_SIZE} />
        </Box>
        <Typography sx={controlLabelStyles} variant="regular12">
          Decline
        </Typography>
      </Box>

      <Box sx={primaryActionCellStyles}>
        <Box
          aria-label="Answer"
          component="button"
          data-testid={IncomingCallActionsTestIds.ANSWER}
          sx={answerButtonStyles}
          onClick={onAnswer}
        >
          <PhoneIcon size={PRIMARY_ACTION_ICON_SIZE} />
        </Box>
        <Typography sx={controlLabelStyles} variant="regular12">
          Answer
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(IncomingCallActions);
